module.exports = __webpack_public_path__ + "img/lh.fc59cd6f.png";